export default {
  "DASHBOARD": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])},
  "THIS_MONTH": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This month"])}
}